export default __webpack_public_path__ + "static/media/videos.410d80ec.svg";